module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_EE-8b9b73e2cd039488f7b4a176b047d0f0.svg";